export default "__VITE_ASSET__91ee82db__"